const nested = {
    svg: '<svg style="width:1.00rem; height:1.00rem;" viewBox="0 0 16 16"><path d="M10.19 4.5A3.42 3.42 0 0 1 13.5 8a3.42 3.42 0 0 1-3.31 3.5A3.41 3.41 0 0 1 6.88 8a3.41 3.41 0 0 1 3.31-3.5m0-1.5a4.91 4.91 0 0 0-4.81 5 4.91 4.91 0 0 0 4.81 5A4.91 4.91 0 0 0 15 8a4.91 4.91 0 0 0-4.81-5M5.81 4.5A3.41 3.41 0 0 1 9.12 8a3.41 3.41 0 0 1-3.31 3.5A3.42 3.42 0 0 1 2.5 8a3.42 3.42 0 0 1 3.31-3.5m0-1.5A4.91 4.91 0 0 0 1 8a4.91 4.91 0 0 0 4.81 5 4.91 4.91 0 0 0 4.81-5 4.91 4.91 0 0 0-4.81-5"/></svg>',
};

export { nested as default };
